import React, { ReactNode } from 'react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { OrderedListOutlined } from '@ant-design/icons';
import { IFieldLayout, IUsageProductsItem } from '../../../interfaces';
import { numberToStringWithSeparator } from '../../../instruments';
import { Catcher } from '../../Catcher';
import { FieldInfoAdvanced } from '../../Forms';
import CardStyles from '../../styles/m_itemCardStyles.less';
import ViewStyles from '../../styles/m_viewStyles.less';
import Styles from '../m_styles.less';

type IDataType = Omit<IUsageProductsItem, 'cost' | 'currency' | 'volume' | 'unitType'> & {
    key: number;
    unitType?: ReactNode;
    volume?: ReactNode;
    cost?: ReactNode;
};

type IShowUsageProducts = {
    isLoading?: boolean;
    layout?: IFieldLayout | undefined;
    usageProducts?: Array<IUsageProductsItem>;
};

export const ShowUsageProducts: React.FC<IShowUsageProducts> = ({
    isLoading,
    layout,
    usageProducts,
}: IShowUsageProducts) => {
    if (!usageProducts?.length) {
        return null;
    }
    const tableColumns: ColumnsType<IDataType> = [
        {
            title: 'Unit Type',
            dataIndex: 'unitType',
            className: ViewStyles.columnCenter,
        },
        {
            title: 'Volume',
            dataIndex: 'volume',
            className: ViewStyles.columnRight,
        },
        {
            title: 'Cost',
            dataIndex: 'cost',
            className: ViewStyles.columnRight,
        },
    ];
    const tableData: IDataType[] = usageProducts.map((item, index) => ({
        key: index,
        unitType: item.unitType?.toUpperCase(),
        volume: numberToStringWithSeparator(item.volume),
        cost: `${item.cost?.toFixed(2)}  ${item.currency?.abbreviation}`,
    }));

    return (
        <Catcher>
            <FieldInfoAdvanced
                icon={<OrderedListOutlined className={CardStyles.labelIcon} />}
                layout={layout}
                title={'Usage Products'}
            />
            <div className={Styles.fieldMargin}>
                <Table
                    className={'table-theme'}
                    columns={tableColumns}
                    dataSource={tableData}
                    loading={isLoading}
                    pagination={false}
                    size={'small'}
                    footer={() => null}
                />
            </div>
        </Catcher>
    );
};
